export default "__VITE_ASSET__C$NC$_jA__"